import * as React from 'react'
import dynamic from 'next/dynamic'

const Credit = dynamic(
  () => import('@thg-commerce/gravity-icons/src/components/ReferralsCredit'),
)
const Code = dynamic(
  () => import('@thg-commerce/gravity-icons/src/components/ReferralsCode'),
)
const Friend = dynamic(
  () => import('@thg-commerce/gravity-icons/src/components/ReferralsFriend'),
)
const Order = dynamic(
  () => import('@thg-commerce/gravity-icons/src/components/ReferralsOrder'),
)
const Account = dynamic(
  () => import('@thg-commerce/gravity-icons/src/components/ReferralsAccount'),
)
const Meal = dynamic(
  () => import('@thg-commerce/gravity-icons/src/components/ReferralsMeal'),
)
const Shop = dynamic(
  () => import('@thg-commerce/gravity-icons/src/components/ReferralsShop'),
)
const Delivery = dynamic(
  () => import('@thg-commerce/gravity-icons/src/components/ReferralsDelivery'),
)
const Vitamin = dynamic(
  () => import('@thg-commerce/gravity-icons/src/components/ReferralsVitamin'),
)
const Referral = dynamic(
  () => import('@thg-commerce/gravity-icons/src/components/ReferralsReferral'),
)

import {
  Title,
  StyledGrid,
  StyledGridItem,
  StepSubtitle,
  Subtitle,
  StepText,
  SVGContainer,
  SmallPrint,
} from './styles'

export enum IconType {
  CODE = 'code',
  CREDIT = 'credit',
  ORDER = 'order',
  FRIEND = 'friend',
  ACCOUNT = 'account',
  REFERRAL = 'referral',
  SHOP = 'shop',
  VITAMIN = 'vitamin',
  DELIVERY = 'delivery',
  MEAL = 'meal',
}

interface ReferralSteps {
  svg: IconType
  subtitle: string
  stepText: string
}

export interface ReferralStepGuideProps {
  title?: string
  subtitle?: string
  smallprint?: string
  step1icon: IconType
  step1title: string
  step1text: string
  step2text: string
  step2icon: IconType
  step2title: string
  step3icon: IconType
  step3text: string
  step3title: string
  className?: string
}

const iconRenderer = (icon: IconType) => {
  switch (icon) {
    case IconType.CODE:
      return <Code aria-hidden />
    case IconType.CREDIT:
      return <Credit aria-hidden />
    case IconType.ORDER:
      return <Order aria-hidden />
    case IconType.FRIEND:
      return <Friend aria-hidden />
    case IconType.ACCOUNT:
      return <Account aria-hidden />
    case IconType.REFERRAL:
      return <Referral aria-hidden />
    case IconType.SHOP:
      return <Shop aria-hidden />
    case IconType.VITAMIN:
      return <Vitamin aria-hidden />
    case IconType.DELIVERY:
      return <Delivery aria-hidden />
    case IconType.MEAL:
      return <Meal aria-hidden />
    default:
      return null
  }
}

export const ReferralStepGuide = (props: ReferralStepGuideProps) => {
  const referralSteps: ReferralSteps[] = [
    {
      svg: props.step1icon,
      stepText: props.step1text,
      subtitle: props.step1title,
    },
    {
      svg: props.step2icon,
      stepText: props.step2text,
      subtitle: props.step2title,
    },
    {
      svg: props.step3icon,
      stepText: props.step3text,
      subtitle: props.step3title,
    },
  ]
  return (
    <div className={props.className}>
      <StyledGrid>
        {(props.title || props.subtitle) && (
          <StyledGridItem colSpan={12} rowStart={1}>
            {props.title && (
              <Title content={props.title} __dangerouslyAllowedTags={['b']} />
            )}
            {props.subtitle && <Subtitle>{props.subtitle}</Subtitle>}
          </StyledGridItem>
        )}
        {referralSteps.map((step, index) => {
          return (
            <StyledGridItem
              key={`referral-step-${index}`}
              breakpoints={['xs', 'sm', 'md', 'lg']}
              colSpan={[12, 12, 4, 4]}
              rowStart={[index + 2, index + 2, 2, 2]}
            >
              <SVGContainer>{iconRenderer(step.svg)}</SVGContainer>
              <StepSubtitle content={step.subtitle} />
              <StepText content={step.stepText} />
            </StyledGridItem>
          )
        })}
      </StyledGrid>
      {props.smallprint && <SmallPrint content={props.smallprint} />}
    </div>
  )
}
